import { useIntl } from 'react-intl';
import { Redirect, useParams } from 'react-router';
import { LinearProgress } from '@rossum/ui/material';
import { SettingsBreadcrumbs } from '../../../containers/Settings/SettingsBreadcrumbs';
import { useGetRule } from '../../rules/hooks/useGetRule';
import { useCombinedRuleQueueUrls } from '../../rules/hooks/useRuleQueue';
import { QueuesPage } from '../../rules/rule-detail/QueuesPage';
import { ruleManagerPath } from '../routes';
import { RuleManagerTabs } from '../RuleManagerTabs';

export const LinkedQueuesRulePage = () => {
  const intl = useIntl();
  const { ruleId } = useParams<{ ruleId: string }>();
  const { data: rule, isLoading: isRuleLoading } = useGetRule(Number(ruleId));
  const { queues: ruleQueues } = useCombinedRuleQueueUrls({ rule });

  const parentPath = ruleManagerPath();

  if (isRuleLoading) {
    return <LinearProgress />;
  }

  if (!rule) {
    return <Redirect to={parentPath} />;
  }

  return (
    <QueuesPage
      rule={rule}
      ruleQueues={ruleQueues}
      parentPath={parentPath}
      renderTabs={() => (
        <RuleManagerTabs
          linkedQueuesDisabled={false}
          value="queues"
          parentPath={`${parentPath}/${rule.id}`}
          queuesLength={ruleQueues.length}
        />
      )}
      renderBreadcrumbs={breadcrumbs => (
        <SettingsBreadcrumbs
          breadcrumbs={[
            {
              label: intl.formatMessage({
                id: 'features.ruleManager.list.title',
              }),
              to: parentPath,
            },
            ...breadcrumbs,
          ]}
        />
      )}
    />
  );
};
